export function addLeadingSlash(path: string) {
  if (path[0] !== '/') {
    return `/${path}`;
  }
  return path;
}
